import * as React from "react";
import { useSelector } from "react-redux";

import styled from "styled-components";
import Main from "./components/Main";
import Info from "./components/Info";
import ChatConversation from "../ChatConversation";
import Sidebar from "../Monitor/components/SideBar";
import { useDispatch } from "react-redux";
import { getGroups } from "../../../actions/groupsAction";
import { getAgents } from "../../../actions/agentsAction";

export interface IMonitorComponentProps {
  chats: any[];
}

const Container = styled.div`
  display: flex;
  height: calc(100vh - 58px - 58px);
`;

export const SelectedChatMonitorMessageContext = React.createContext({
  selectedChat: "",
  setSelectedChat: (arg: any) => { },
});

export const MonitorChatContext = React.createContext({
  userTextTyping: {},
  setUserTextTyping: (arg: any) => { },
});


export default function MonitorComponent(props: IMonitorComponentProps) {
  // const [selectedChat, setSelectedChat] = React.useState("");
  const [userTextTyping, setUserTextTyping] = React.useState({});
  const clientConversation = useSelector((state: any) => state.ui.clientConversation);
  const dispatch = useDispatch();
  const fetchGroups = React.useCallback(() => dispatch(getGroups()), [
    dispatch,
  ]);
  const fetchAgents = React.useCallback(() => dispatch(getAgents()), [
    dispatch,
  ]);

  React.useEffect(() => {
    fetchGroups();
    fetchAgents();
  }, []);

  return (
    <Container>
      <MonitorChatContext.Provider value={{ userTextTyping, setUserTextTyping }}>
        <Sidebar />
        <Main />
        <ChatConversation clientConversation={clientConversation} />
        <Info clientConversation={clientConversation} />
      </MonitorChatContext.Provider>
    </Container>
  );
}
